import { FaClipboardUser, FaRankingStar, FaToolbox } from "react-icons/fa6";
import { BiCog, BiFile } from "react-icons/bi";
import { RiAdminFill } from "react-icons/ri";
import { IoIosListBox } from "react-icons/io";
import { BsCashCoin, BsClipboardCheck, BsReceipt, BsCurrencyExchange } from "react-icons/bs";
import { ImPriceTags, ImUsers } from "react-icons/im";
import { AiOutlineOrderedList } from "react-icons/ai";
import { TbBoxMultiple } from "react-icons/tb";
import { MdDashboard, MdFactory, MdInventory, MdLocationOn, MdManageAccounts, MdOutlinePointOfSale, MdSecurity, MdTask } from "react-icons/md";
import { FaHome, FaStore, FaBox, FaUsers, FaBan, FaClipboardList } from "react-icons/fa";
import { LiaCashRegisterSolid, LiaMoneyCheckSolid } from "react-icons/lia";
import { CiBoxes } from "react-icons/ci";
import { HiOutlineReceiptRefund, HiOutlineReceiptTax } from "react-icons/hi";

import { ReportTypes } from "pages/reports/constants/Reports";

/**
 * Opciones del menú lateral. Es la única fuente de nombres y rutas: la usan el menú y la barra
 * superior (ubicación actual). Los íconos se guardan como componentes para elegir el tamaño al dibujarlos.
 */
export const MENU_TOP_ITEMS = [
  { label: "Dashboard", path: "/dashboard", icon: MdDashboard },
  { label: "Inicio", path: "/", icon: FaHome },
];

export const MENU_GROUPS = [
  {
    id: "headlines",
    title: "Titulares",
    icon: ImUsers,
    items: [
      { label: "Socios de negocio", path: "/partners", icon: FaStore },
      { label: "Grupos", path: "/groups/partners", icon: ImUsers },
      { label: "Vendedores", path: "/sellers", icon: FaClipboardUser },
    ],
  },
  {
    id: "financial",
    title: "Financiero",
    icon: LiaCashRegisterSolid,
    items: [
      { label: "Caja actual", path: "/current/cash_register", icon: BsCashCoin },
      { label: "Caja", path: "/cash_register", icon: LiaCashRegisterSolid },
      { label: "Cotizaciones", path: "/dollar_quotation", icon: BsCurrencyExchange },
    ],
  },
  {
    id: "articles",
    title: "Articulos",
    icon: MdInventory,
    items: [
      { label: "Listado", path: "/articles", icon: FaBox },
      { label: "Familias", path: "/families", icon: IoIosListBox },
      { label: "Unidades", path: "/units", icon: AiOutlineOrderedList },
      { label: "Lista de precios", path: "/prices", icon: ImPriceTags },
    ],
  },
  {
    id: "documents",
    title: "Documentos",
    icon: BsClipboardCheck,
    items: [
      { label: "Listado", path: "/documents", icon: BsClipboardCheck },
      { label: "Recibos", path: "/receipts", icon: BsReceipt },
      { label: "Resguardos", path: "/resguardos", icon: HiOutlineReceiptRefund },
      { label: "Cheques", path: "/checks", icon: LiaMoneyCheckSolid },
    ],
  },
  {
    id: "inventory",
    title: "Inventario",
    icon: MdFactory,
    items: [
      { label: "Producciones", path: "/productions", icon: MdFactory },
      { label: "Lotes", path: "/lots", icon: TbBoxMultiple },
    ],
  },
  {
    id: "management",
    title: "Gestión",
    icon: MdManageAccounts,
    items: [
      { label: "Tipos de documentos", path: "/document/types", icon: AiOutlineOrderedList },
      { label: "Indicadores de facturación", path: "/indicators", icon: AiOutlineOrderedList },
      { label: "Localidades", path: "/locations", icon: MdLocationOn },
    ],
  },
  {
    id: "security",
    title: "Seguridad",
    icon: MdSecurity,
    items: [
      { label: "Usuarios", path: "/users", icon: FaUsers },
      { label: "Roles", path: "/roles", icon: RiAdminFill },
      { label: "Tareas", path: "/tasks", icon: MdTask },
    ],
  },
  {
    id: "reports",
    title: "Reportes",
    icon: BiFile,
    items: [
      { label: "Ranking de Ventas", path: `/reports/${ReportTypes.SALES_RANKING}`, icon: FaRankingStar },
      { label: "Crédito pendiente", path: `/reports/${ReportTypes.PENDING_CREDIT}`, icon: FaBan },
      { label: "Inventario (Stock)", path: `/reports/${ReportTypes.STOCK}`, icon: CiBoxes },
      { label: "Saldo de socios", path: `/reports/${ReportTypes.PARTNERS_BALANCE}`, icon: BsCashCoin },
      { label: "Resumen de IVA", path: `/reports/${ReportTypes.TAX}`, icon: HiOutlineReceiptTax },
      { label: "Utilidades en un periodo", path: `/reports/${ReportTypes.UTILITIES}`, icon: FaToolbox },
      { label: "Última venta por cliente", path: `/reports/${ReportTypes.LAST_PURCHASE_BY_CLIENT}`, icon: MdOutlinePointOfSale },
      { label: "Ventas por vendedor", path: `/reports/${ReportTypes.SELLER}`, icon: FaClipboardUser },
      { label: "Socios por vendedor", path: `/reports/${ReportTypes.PARTNER_BY_SELLER}`, icon: FaClipboardList },
    ],
  },
];

export const MENU_BOTTOM_GROUPS = [
  {
    id: "tools",
    title: "Herramientas",
    icon: FaToolbox,
    items: [
      { label: "Recálculos", path: "/tools/stock-recalculation", icon: CiBoxes },
    ],
  },
];

export const MENU_CONFIG_ITEM = { label: "Configuración", path: "/config", icon: BiCog };

// Pantallas que no están en el menú pero tienen nombre en la barra superior
const OTHER_SCREENS = [
  { label: "Cambiar contraseña", path: "/change-password" },
  { label: "Mi perfil", path: "/profile" },
];

const matchesPath = (sPathname, sItemPath) => {
  if (sItemPath === "/") return sPathname === "/";
  return sPathname === sItemPath || sPathname.startsWith(`${sItemPath}/`);
};

/**
 * Devuelve la ubicación de una ruta como lista de textos, ej: "/receipts/new" -> ["Documentos", "Recibos", "Nuevo"]
 */
export const GetBreadcrumb = (sPathname = "/") => {
  const aCandidates = [
    ...MENU_TOP_ITEMS.map(oItem => ({ aParents: [], oItem })),
    ...[...MENU_GROUPS, ...MENU_BOTTOM_GROUPS].flatMap(oGroup => oGroup.items.map(oItem => ({ aParents: [oGroup.title], oItem }))),
    { aParents: [], oItem: MENU_CONFIG_ITEM },
    ...OTHER_SCREENS.map(oItem => ({ aParents: [], oItem })),
  ];

  // La ruta más larga que coincide es la más específica (ej: "/groups/partners" antes que "/partners")
  const oMatch = aCandidates
    .filter(({ oItem }) => matchesPath(sPathname, oItem.path))
    .sort((oA, oB) => oB.oItem.path.length - oA.oItem.path.length)[0];

  if (!oMatch) return [];

  const aCrumbs = [...oMatch.aParents, oMatch.oItem.label];
  if (sPathname !== oMatch.oItem.path) aCrumbs.push(sPathname.endsWith("/new") ? "Nuevo" : "Detalle");
  return aCrumbs;
};

/**
 * Grupo del menú que contiene la ruta actual, para dejarlo abierto al entrar
 */
export const GetGroupIdForPath = (sPathname = "/") => {
  const oGroup = [...MENU_GROUPS, ...MENU_BOTTOM_GROUPS].find(oItem => oItem.items.some(oChild => matchesPath(sPathname, oChild.path)));
  return oGroup?.id ?? null;
};
